@if (order) {
  <lfw-form-edit-toolbar>
    <ng-container toolbar-left>
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.SAVE' | translate }}"
        icon="save"
        (click)="save()"
        [disabled]="!canSave()">
      </lfw-toolbar-button>
      <lfw-toolbar-divider class="desktop-only" />
      <lfw-toolbar-button
        class="desktop-only"
        [disabled]="true"
        label="{{ 'ORDERS.FINISH' | translate }}"
        icon="check_circle"
        [tooltip]="'ORDERS.FINISH_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate"
        (click)="finalize()">
      </lfw-toolbar-button>
    </ng-container>

    <ng-container toolbar-center>
      <lfw-toolbar-text text="{{ caption }}" />
    </ng-container>

    <ng-container toolbar-right>
      @if (order.form) {
        <lfw-sub-state-select
          [availableStates]="order.form.subStates"
          (changed)="subStateSelectionChanged()"
          [(order)]="order.form.order" />
      }

      <lfw-order-editor-mobile-menu
        [canSave]="canSave()"
        [canFinalize]="false"
        (save)="save()"
        (finalize)="finalize()"
        [tooltipForFinalizeButton]="'ORDERS.FINISH_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate"
        (closeForm)="close()" />

      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        (click)="close()" />
    </ng-container>
  </lfw-form-edit-toolbar>

  <lfe-liveforms-editor
    #editor
    [form]="order.form"
    [userInfo]="user"
    [settings]="editorSettings"
    (formChanged)="formChanged()" />
}
